module.exports = __webpack_public_path__ + "img/moph.0706d184.gif";